/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Tab } from '@mui/material';
import { globalBreak } from '@/styles/break';

export const catalogEntryListContainerSX: SxProps = {
	flex: 1,
	height: 'auto',
};

export const plpSelectSX:SxProps = {
	width:globalBreak({mobile:'40px',desktop:'100%'}),
	fontSize:globalBreak({mobile:'14px !important', desktop:'16px !important'}),
	alignSelf:'flex-end',
	'& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input':{
		width:globalBreak({mobile:'0',desktop:'inherit'}),
		color:globalBreak({mobile:'#fff', desktop:'#000'})
	}
}

export const plpPaginationSX:SxProps = {
	'& .MuiPaginationItem-root':{
		margin:globalBreak({mobile:0, desktop:0.5}),
		padding:globalBreak({mobile:0, desktop:0.5}),
		minWidth:globalBreak({mobile:24, desktop:32}),
		fontWeight:400,
		fontSize:globalBreak({mobile:'14px !important', desktop:'16px !important'}),
		color:'#424242'
	},
	'& .MuiPaginationItem-root.Mui-selected':{
		fontWeight:'bold'
	},
	'& .MuiPaginationItem-root.MuiPaginationItem-ellipsis':{
		maxWidth:globalBreak({mobile:16, desktop:32}),
	}
}

export const cardNameSx:SxProps = {
	'& > a ':{
		fontSize:16,
		fontWeight:'bold'
	}
}

export const sortByTextSx:SxProps = {
		fontSize:globalBreak({mobile:'14px !important', desktop:'16px !important'}),
		px:1
}

export const resultsHeaderSx:SxProps = {
		borderBottom: '1px solid #545454',
		alignItems:'center',
		fontSize: globalBreak({mobile:'14px !important', desktop:'16px !important'}),
		minHeight:65,
		justifyContent:'space-between',
		flexDirection:'row',
}

export const articleCountSx:SxProps = {
		fontSize:globalBreak({mobile:'14px !important', desktop:'16px !important'}),
		color:'#424242',
		width:globalBreak({mobile:'17%', desktop:'auto'})
}